let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jtON9")).then(() => parcelRequire('cfAGP'));